import {Col, Container, Row} from "react-bootstrap";
import logo from "../images/logo.png";
import classes from "../styles/components/header.module.scss";
import {NavLink} from "react-router-dom";
import { IoCartOutline } from "react-icons/io5";
import {paths} from "../storage/paths";

function Header(){
    return(
        <Container fluid className={classes.header}>
            <Row>
                <Col xl={3} lg={3} md={3} sm={12} xs={12}>
                    <NavLink to={paths.home}><img className={classes.logo} src={logo}/></NavLink>
                </Col>
                <Col xl={7} lg={7} md={7} sm={12} xs={12}>
                    <div className={classes.navLinks}>
                        <NavLink to={paths.services} className={classes.navLink}>Services</NavLink>
                        <NavLink to={paths.shop} className={classes.navLink}>Shop</NavLink>
                        <NavLink to={paths.contact} className={classes.navLink}>Contact</NavLink>
                    </div>
                </Col>
                <Col className="d-none d-md-block">
                    <NavLink to={paths.cart}><IoCartOutline className={classes.cart}/></NavLink>
                </Col>
            </Row>

            <div className={classes.circle}>
                <NavLink to={paths.cart}><IoCartOutline className={classes.circleCart}/></NavLink>
            </div>
        </Container>
    );
}

export default Header;